import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

/**
 * Prevents unnecessary re-renders when nested properties within persons change
 * NOTE - named selector function is useful for debugging
 */
export function usePersons() {
  return useSelector(
    function personsSelector(state) {
      return state.questionnaire.persons
    },
    (objA, objB) => {
      if (isEmpty(objA) || isEmpty(objB)) {
        return objA === objB
      }
      const stringSort = (a, b) => a.localeCompare(b)

      return (
        JSON.stringify(Object.keys(objA).sort(stringSort)) ===
        JSON.stringify(Object.keys(objB).sort(stringSort))
      )
    },
  )
}

export function useLocalization() {
  return useSelector((state) => state.localization)
}

export function useProband() {
  return useSelector((state) => {
    const probandId = state.questionnaire.probandId

    return state.questionnaire.persons[probandId]
  })
}
